<template>
  <transition name="fade">
    <div class="login-popup" v-if="visible">
      <div class="popup-shadow" @click="hidePopup"></div>
      <div class="popup-container">
        <a href="javascript:;" class="popup-close" @click="hidePopup">
          <em class="icon"></em>
        </a>
        <img class="login-bg" v-if="loginBg" :src="loginBg" alt="login-bg" />
        <div class="login-title">
          {{ titleText }}
        </div>
        <account-login></account-login>
      </div></div
  ></transition>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import AccountLogin from '@components/officialTopupNew/login/AccountLogin.vue';
export default {
  name: 'AccountLoginPopup',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      picList: state => state.page.picList,
      lang: state => state.lang,
      gameId: state => state.gameId
    }),
    loginBg() {
      return this.picList?.loginbanner || '';
    },
    titleText() {
      let text = this.letter.login;
      if (+this.gameId === 386) {
        const langText = {
          'en-US': 'Login to game role',
          'zh-CN': '登入游戏角色',
          'zh-TW': '登入遊戲角色'
        };
        text = langText[this.lang] || text;
      }
      return text;
    }
  },
  methods: {
    hidePopup() {
      this.$emit('update:visible', false);
    }
  },
  components: {
    AccountLogin
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';
.login-popup {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  ::v-deep .account-login-content {
    width: 100%;
  }
}
.popup-shadow {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}
.popup-container {
  position: relative;
  box-sizing: border-box;
  border-radius: 20px;
  background: #fff;
}
.login-bg {
  width: 100%;
  border-radius: 20px 20px 0 0;
}

.login-title {
  padding: 40px 40px 50px;
  text-align: center;
  line-height: 1.2;
  font-size: 28px;
  margin: 0;
  border-radius: 20px;
  font-weight: bold;
  color: #333333;
}

.popup-close {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  right: -40px;
  top: -40px;
  width: 48px;
  height: 48px;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
  .icon {
    display: block;
    background: url($commonImg + 'close.png') no-repeat;
    width: 28px;
    height: 28px;
  }
}

@media screen and (orientation: landscape) {
  .popup-container {
    width: $landscapePopupWidth;
    ::v-deep .uid-token-content {
      width: 100%;
    }
    ::v-deep .third-login .space .line {
      width: 368px;
    }
  }
  .title {
    height: 61px;
    line-height: 61px;
    font-size: 22px;
  }
}
</style>
